import React, { useState, useEffect } from 'react';

import '../ContactForm.css'; // Assuming your provided CSS is stored in this file
import '../ButtonBar.css';
import ContactFormStandardMovex from './STANDARDCONTRACTFORM';
import ReturnJobform from './ReturnJobContractForm';
import MultidropoffVehicleForm from './Multidropoffform';
import Onwardvehicle from './OnwardVehicle';

import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Carousel from '../../Carousel/Carousel';
const ContactFormMovex = () => {
  const navigate=useNavigate();

  const [formContent, setFormContent] = useState('STANDARD');
  
  const imagesWithText = [
    
    { image: "/truck1.jpg"},
    { image: "/truck2.jpg"}
  ];

const onloginclick=(e)=>{
  navigate("/Logistics/Login");
}
const onSignupclick=(e)=>{
  navigate("/Logistics/Signup");
}
  
const [usertype, setUserType]=useState('Business')
const handleoptionPress=(e)=>{
  const selectedValue=e.target.value;
  switch (selectedValue){
    case 'Business':
      setUserType('Business');
      break;
      case 'Individual':
        setUserType('Individual');
      break;
  }
}
const handleloginpress =(e)=>{
  navigate("/Logistics/Home");
}
  const handleoptionPress2 = (e) => {
    const selectedValue = e.target.value; // Get the selected value from the event
    switch (selectedValue) {
      case 'STANDARD':
        
        setFormContent('STANDARD');
        break;
      case 'RETURN JOB':
        setFormContent('RETURN JOB');
        break;
      case 'ONWARD VEHICLES':
        setFormContent('ONWARD VEHICLES');
        break;
      case 'MULTI DROP OFF':
        setFormContent('MULTI DROP OFF');
        break;
      default:
        setFormContent('');

    }
      }
     

  return (
    <>
    <Helmet>
    <title>Zoom Autos - Get A Quote</title>
    <meta name="description" content="Get a free quote for fast and secure car transport services with Zoom Autos. Nationwide vehicle delivery across the UK. Fill out the form for a personalized quote." />
<meta name="keywords" content="get a quote, car transport quote, vehicle delivery quote, UK car shipping, car moving service, Zoom Autos quote" />
<meta property="og:title" content="Zoom Autos- Get a Quote" />
<meta property="og:description" content="Request a free, no-obligation car transport quote from Zoom Autos. Fast and reliable nationwide car shipping service." />
<meta name="geo.region" content="GB" />
<meta name="geo.placename" content="London" /> 
<meta name="ICBM" content="51.5074, 0.1278" /> 

</Helmet>
    <Carousel imagesWithText={imagesWithText}/>
    
    <div className='overlay-text'>
      <h1>Welcome To Zoom Autos</h1>
      <h2 style={{ color:'red'}} >Get A Quote</h2>
      
    </div>
    
    <h1>Sub Contract Form</h1>
    <div className="move-container">
        
      <div className="mve-form">
    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>
  <h2>Are You a </h2>
  <select 
 
    onChange={handleoptionPress} 
    style={{ width: 'max-content' }}
  >
    <option value="Business">Business</option>
    <option value="Individual">Individual</option>
  </select>
  <h2>?</h2>
  </div>  
  

{
  usertype==="Business" &&(
    <>
    <div className='stats'>
      <button className='contact-button' type='button' onClick={onloginclick}>Login</button>
      
      <button className='contact-button' type='button' onClick={onSignupclick}>Register</button>
      
    </div>
    </>
  )
    
  }



  

{
  usertype==="Individual" &&(
    <>
    {/* Car Owner Details */}
    <div className="form-group">
  <h2>Service Type</h2>
  <select 
 
    onChange={handleoptionPress2} 
    style={{ width: 'max-content' }}
  >
    <option value="STANDARD">STANDARD</option>
    <option value="RETURN JOB">RETURN JOB</option>
    <option value="ONWARD VEHICLES">ONWARD VEHICLES</option>
    <option value="MULTI DROP OFF">MULTI DROP OFF</option>
  </select>
</div>
    </>
  )
    
  }


        
      

            

{
            formContent ==='STANDARD' && usertype==='Individual'&&(
              <ContactFormStandardMovex/>
            )

          }
          {
            formContent === 'RETURN JOB' && usertype==='Individual'&&(
         <ReturnJobform/>
            )

          }
          
      
            {formContent === 'ONWARD VEHICLES' && usertype==='Individual'&&(
<Onwardvehicle/>

                                )}
            {formContent === 'MULTI DROP OFF' && usertype==='Individual'&&(
              <MultidropoffVehicleForm/>
              )
            }
      </div>
      
    </div>
    </>
  );
};

export default ContactFormMovex;
